/* eslint-disable @typescript-eslint/naming-convention */

export enum OtherConcerns {
	"手がかさつく",
	"爪が割れる",
	"髪がパサつく",
	"髪にハリ・コシがない",
	"髪が抜けやすい",
	"かかとがかさつく",
	"足がむくむ",
	"手足が冷える",
	"全身が乾燥する",
	"身体の疲れ",
}
